import React from 'react'

const NavigationDot = ({active}) => {
  return (
    <div className='app__navigation'>
        {['home', 'about','education','skills','certification','works','contact'].map((item, index)=>(
                <a 
                href={`#${item}`}
                key = {item + index}
                className = "app__navigation-dot" 
                style={ active === item ? {backgroundColor: ' #313BAC' } : { } }
                
                >
                </a>
            ))}
    </div>
  )
}

export default NavigationDot